<script>
export default {
  props: { id: { required: true } },

  created() {
    this.refresh()
  },

  data() {
    return {
      loading: true
    }
  },

  computed: {
    application() {
      return this.$store.getters['admin/applications/find'](this.id)
    }
  },

  methods: {
    refresh() {
      return this.$store.dispatch('admin/applications/fetch', this.id).then(
        () => (this.loading = false),
        errors => {
          this.loading = false
          this.$store.dispatch('snackbarError', 'Application not Found')
          this.$emit('close')
        }
      )
    }
  },

  render() {
    return this.$scopedSlots.default({
      application: this.application,
      loading: this.loading,
    })
  }
}
</script>
